export const roundAmount = (amount) => {
    return Number(amount.toFixed(2));
};